module.exports = __webpack_public_path__ + "img/deposit.448bb81e.png";